import g from '#core/global';
import events from '#core/events';
import load from '#core/load';


const component_$ = '.wysiwyg-expandable.\\:once-true';
const inner_$ = '.wysiwyg-expandable__inner';
const button_container_$ = '.wysiwyg-expandable__button-container';


const module = {

	/**
	 * Init module
	 */
	init() {
		if (load.ran('wysiwyg-expandable')) return false;

		load.content(() => {
			const $components = document.querySelectorAll(component_$);
			if (!$components.length) return false;

			assign_elements();
		});
	},

};

export default module;
module.init();


/**
 * Assign elements and event listeners
 */
function assign_elements() {
	document.addEventListener(events.expandable.toggle_start, e => {
		if (!e.detail || !e.detail.is_active) return;

		const $expandable = e.target;
		const $component = $expandable.closest(component_$);
		if (!$component) return;

		const $inner = $component.querySelector(inner_$);
		const $button_container = $component.querySelector(button_container_$);
		if (!$inner || !$button_container) return;

		lock_and_collapse($inner, $button_container, $expandable);
	});
}


/**
 * Lock inner height and collapse the expandable cleanly
 * @param {HTMLElement} $inner
 * @param {HTMLElement} $button_container
 * @param {HTMLElement} $expandable
 */
function lock_and_collapse($inner, $button_container, $expandable) {
	// Lock the inner container height so removing the button from flow
	// doesn't cause a visual snap
	$inner.style.minHeight = $inner.offsetHeight + 'px';

	// Remove button from flow — min-height prevents collapse
	$button_container.style.position = 'absolute';

	// Clean up after the expandable finishes its grid-template-rows transition
	$expandable.addEventListener(g.transition_end_e, function done(e) {
		if (e.target !== $expandable) return;
		
		$expandable.removeEventListener(g.transition_end_e, done);
		$inner.style.minHeight = '';
		$button_container.setAttribute(g.hidden_attr, '');
		$button_container.style.position = '';
	});
}
